module.exports = __webpack_public_path__ + "d94e20c1/img/arrow-left-icon.785c715c.svg";